import { useAuthStore } from '@/store/auth-store';
import { sessionScope } from '@/features/auth/session-scope';

// Realtime imports keys only, never the lazy SDK/mutation implementation.
export const contactPurgeKey = (scope = sessionScope(useAuthStore.getState())) => ['contact-purge', scope] as const;
export const isContactPurgeId = (value:unknown):value is string => typeof value === 'string' && /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(value) && !/^0{8}(?:-0{4}){3}-0{12}$/.test(value);
/** Explicit base-role exception in the canonical purge API contract. */
export function canPurgeContacts(role: string | null): boolean {
  return role === 'admin' || role === 'super_admin' || role === 'owner';
}
